import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "border-b border-gray-200" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = {
  key: 0,
  class: "bg-red-600 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center"
}
const _hoisted_4 = {
  key: 0,
  class: "overflow-x-auto"
}
const _hoisted_5 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_6 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_7 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_8 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_9 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_10 = { class: "text-sm text-gray-500" }
const _hoisted_11 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_12 = { class: "px-3 py-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800" }
const _hoisted_13 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_14 = { class: "px-6 py-4 whitespace-nowrap text-right text-sm font-medium" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  colspan: "5",
  class: "px-6 py-4 bg-gray-50 border-t border-gray-200"
}
const _hoisted_18 = { class: "flex space-x-3" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 1,
  class: "text-sm text-gray-500 italic"
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 1,
  class: "overflow-x-auto"
}

import { ref } from 'vue';
  import RemindersTab from './RemindersTab.vue';
  import EmailReviewModal from '../EmailReviewModal.vue';
  import { TaskDocProfile } from '@/features/task-management';
  import { useEmailReminder } from '@/composables/useEmailReminder';
  
  // Props with proper typing
  
export default /*@__PURE__*/_defineComponent({
  __name: 'TaskView',
  props: {
    myTasks: {
      type: Array as () => TaskDocProfile[],
      required: true
    },
    allTasks: {
      type: Array as () => TaskDocProfile[],
      required: true
    },
    reminders: {
      type: Array as () => TaskDocProfile[],
      required: true
    },
    overdueRemindersCount: {
      type: Number,
      required: true
    },
    canViewReminders: {
      type: Boolean,
      required: true
    }
  },
  setup(__props) {

  
  
  // State
  const activeTab = ref('my-tasks');
  const expandedTaskId = ref<string | null>(null);
  
  // Use the email reminder composable
  const {
    showEmailModal,
    currentTaskData,
    showEmailReminderModal,
    closeEmailModal,
    handleEmailSendSuccess
  } = useEmailReminder();
  
  // Alias the showEmailReminderModal function to maintain the original function name
  const showTaskMessage = showEmailReminderModal;
  
  // Toggle expanded task
  const toggleTaskExpanded = (taskId: string) => {
    if (expandedTaskId.value === taskId) {
      expandedTaskId.value = null;
    } else {
      expandedTaskId.value = taskId;
    }
  };
  
  
  // Format date
  const formatDate = (dateString: string | null | undefined) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };
  
  // Get due date class based on date
  const getDueDateClass = (dateString: string | null | undefined) => {
    if (!dateString) return 'text-gray-500';
    
    const dueDate = new Date(dateString);
    const today = new Date();
    
    // Reset time part for accurate day calculation
    dueDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    
    if (dueDate < today) {
      return 'text-red-500'; // Overdue
    } else if (dueDate.getTime() === today.getTime()) {
      return 'text-yellow-500'; // Due today
    } else {
      return 'text-gray-500'; // Future
    }
  };
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (activeTab.value = 'my-tasks')),
          class: _normalizeClass(["px-4 py-2 border-b-2 font-medium transition-colors duration-200", activeTab.value === 'my-tasks' ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700'])
        }, " My Tasks ", 2),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (activeTab.value = 'all-tasks')),
          class: _normalizeClass(["px-4 py-2 border-b-2 font-medium transition-colors duration-200", activeTab.value === 'all-tasks' ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700'])
        }, " All Tasks ", 2),
        (__props.canViewReminders)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (activeTab.value = 'reminders')),
              class: _normalizeClass(["px-4 py-2 border-b-2 font-medium transition-colors duration-200 flex items-center space-x-2", activeTab.value === 'reminders' ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700'])
            }, [
              _cache[3] || (_cache[3] = _createElementVNode("span", null, "Reminders", -1)),
              (__props.overdueRemindersCount > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.overdueRemindersCount), 1))
                : _createCommentVNode("", true)
            ], 2))
          : _createCommentVNode("", true)
      ])
    ]),
    (activeTab.value === 'my-tasks' || activeTab.value === 'all-tasks')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _cache[7] || (_cache[7] = _createElementVNode("thead", { class: "bg-gray-50" }, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                }, "Document"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                }, "User"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                }, "Action"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                }, "Due Date"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "relative px-6 py-3"
                }, [
                  _createElementVNode("span", { class: "sr-only" }, "Actions")
                ])
              ])
            ], -1)),
            _createElementVNode("tbody", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeTab.value === 'my-tasks' ? __props.myTasks : __props.allTasks, (task) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: task.id
                }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(task.document_name), 1)
                    ]),
                    _createElementVNode("td", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, _toDisplayString(task.user_name), 1)
                    ]),
                    _createElementVNode("td", _hoisted_11, [
                      _createElementVNode("span", _hoisted_12, _toDisplayString(task.action), 1)
                    ]),
                    _createElementVNode("td", _hoisted_13, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["text-sm", getDueDateClass(task.due_at)])
                      }, _toDisplayString(formatDate(task.due_at)), 3)
                    ]),
                    _createElementVNode("td", _hoisted_14, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (toggleTaskExpanded(task.id)),
                        class: _normalizeClass(["text-primary hover:text-primary-dark transition-transform duration-200", { 'transform rotate-180': expandedTaskId.value === task.id }])
                      }, _cache[4] || (_cache[4] = [
                        _createElementVNode("svg", {
                          class: "h-5 w-5",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24",
                          xmlns: "http://www.w3.org/2000/svg"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M19 9l-7 7-7-7"
                          })
                        ], -1)
                      ]), 10, _hoisted_15)
                    ])
                  ]),
                  (expandedTaskId.value === task.id)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                        _createElementVNode("td", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            (task.action === 'DOWNLOAD' && __props.canViewReminders)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  onClick: ($event: any) => (_unref(showTaskMessage)(task.document_id, task.user_name, task.user_email, task.action)),
                                  class: "inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                                }, _cache[5] || (_cache[5] = [
                                  _createElementVNode("svg", {
                                    class: "h-4 w-4 mr-1",
                                    fill: "none",
                                    stroke: "currentColor",
                                    viewBox: "0 0 24 24",
                                    xmlns: "http://www.w3.org/2000/svg"
                                  }, [
                                    _createElementVNode("path", {
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      "stroke-width": "2",
                                      d: "M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                                    })
                                  ], -1),
                                  _createTextVNode(" Send Reminder ")
                                ]), 8, _hoisted_19))
                              : (_openBlock(), _createElementBlock("div", _hoisted_20, " No actions available "))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128)),
              ((activeTab.value === 'my-tasks' ? __props.myTasks : __props.allTasks).length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_21, _cache[6] || (_cache[6] = [
                    _createElementVNode("td", {
                      colspan: "5",
                      class: "px-6 py-10 text-center"
                    }, [
                      _createElementVNode("p", { class: "text-gray-500" }, "No tasks available")
                    ], -1)
                  ])))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (activeTab.value === 'reminders' && __props.canViewReminders)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createVNode(RemindersTab, { reminders: __props.reminders }, null, 8, ["reminders"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(EmailReviewModal, {
      "is-open": _unref(showEmailModal),
      "process-step-type": _unref(currentTaskData).action,
      "recipient-email": _unref(currentTaskData).email,
      "template-variables": _unref(currentTaskData),
      onClose: _unref(closeEmailModal),
      onSendSuccess: _unref(handleEmailSendSuccess)
    }, null, 8, ["is-open", "process-step-type", "recipient-email", "template-variables", "onClose", "onSendSuccess"])
  ]))
}
}

})